<template>
  <MainContainer />
</template>

<script>
import MainContainer from "./containers/MainContainer.vue";
import { mapMutations, mapGetters } from "vuex";
export default {
  name: "signin",
  components: { MainContainer },
  async mounted() {
    window.document.title = "Login | Evolution";
  },
  methods: {
    ...mapMutations(["setApiKeyMutation", "setApiRefreshTokenMutation"]),
  },
  computed: {
    ...mapGetters(["getApiKey", "getUserData", "getAccessToken"]),
  },
};
</script>
